import {
  AfterViewInit,
  ChangeDetectorRef,
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  Renderer2
} from '@angular/core';

@Directive({
  selector: 'input[autoWidth], textarea[autoWidth]',
  standalone: true,
})
export class AutoWidthDirective implements OnDestroy, AfterViewInit {

  @Input() minWidth: number = 40;
  @Input() extraWidth: number = 25;

  private ghostElement!: HTMLElement;

  constructor(
    private el: ElementRef,
    private cdr: ChangeDetectorRef,
    private renderer: Renderer2,
  ) {
  }

  ngAfterViewInit() {
    this.createGhostElement();
    // Forzar detección de cambios antes de actualizar el ancho
    setTimeout(() => {
      this.updateWidth();
      this.cdr.detectChanges();
    }, 0);
  }

  ngOnDestroy() {
    if (this.ghostElement) {
      this.renderer.removeChild(document.body, this.ghostElement);
    }
  }

  @HostListener('input')
  onInput() {
    this.updateWidth();
  }

  // Opcional: Ajustar al ganar foco
  @HostListener('focus')
  onFocus() {
    this.updateWidth();
  }

  // Opcional: Mantener ancho mínimo al perder foco
  @HostListener('blur')
  onBlur() {
    if (!this.el.nativeElement.value) {
      this.renderer.setStyle(this.el.nativeElement, 'width', this.minWidth + 'px');
    }
  }

  private createGhostElement() {
    this.ghostElement = this.renderer.createElement('div');
    this.renderer.setStyle(this.ghostElement, 'position', 'absolute');
    this.renderer.setStyle(this.ghostElement, 'visibility', 'hidden');
    this.renderer.setStyle(this.ghostElement, 'white-space', 'nowrap');
    this.renderer.setStyle(this.ghostElement, 'font', this.getFontStyle());
    this.renderer.appendChild(document.body, this.ghostElement);
  }

  private getFontStyle(): string {
    const style = window.getComputedStyle(this.el.nativeElement);
    return `${style.fontStyle} ${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;
  }

  private updateWidth() {
    const value = this.el.nativeElement.value || this.el.nativeElement.placeholder;
    this.renderer.setProperty(this.ghostElement, 'textContent', value);

    const newWidth = Math.max(this.ghostElement.offsetWidth + this.extraWidth, this.minWidth);

    this.renderer.setStyle(this.el.nativeElement, 'width', `${newWidth}px`);
  }
}
